import { useSelector } from 'react-redux'
import { selectStation } from 'store/selectors/station'

import StationControlSection from '../StationDetails/StationControlSection/StationControlSection'
import StationSoftwareSection from '../StationDetails/StationSoftwareSection/StationSoftwareSection'
import StationStepsSection from '../StationDetails/StationStepsSection/StationStepsSection'
import style from '../StationDetails/StationDetails.module.css'
import { useStationControlBoard } from './useStationControlBoard'

/** Station → Control: one board poll, one lotGate, shared UI lock. */
const StationControl = () => {
  const station = useSelector(selectStation)
  const boardState = useStationControlBoard(station)

  if (boardState.feedback === 'no_feedback') {
    return null
  }

  return (
    <div className={style.root}>
      <div className={style.tableWrapper}>
        <StationStepsSection boardState={boardState} stationId={station.id} />
        <StationControlSection boardState={boardState} stationId={station.id} />
        <StationSoftwareSection boardState={boardState} stationId={station.id} />
      </div>
    </div>
  )
}

export default StationControl
